import { render, staticRenderFns } from "./VerificationStatus.vue?vue&type=template&id=3ae68566&"
import script from "./VerificationStatus.vue?vue&type=script&lang=js&"
export * from "./VerificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports